export default __webpack_public_path__ + "static/media/CNo.92-7.9fd881e9.jpg";